module.exports = __webpack_public_path__ + "static/media/add-message.610c6603.svg";